import { render } from "./CarterrPage.vue?vue&type=template&id=48de73b5&scoped=true"
import script from "./CarterrPage.vue?vue&type=script&lang=js"
export * from "./CarterrPage.vue?vue&type=script&lang=js"

import "./CarterrPage.vue?vue&type=style&index=0&id=48de73b5&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48de73b5"]])

export default __exports__